<script> 
import { Line } from 'vue-chartjs'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { hexToRgba } from '@coreui/coreui-pro/dist/js/coreui-utilities'

export default {
  components: {
    hexToRgba,
    CustomTooltips
  },
  extends: Line,
  mounted () {
    this.renderChart(
      {
        labels: [
          'Jul 1, 19',
          'Jul 2, 19',
          'Jul 3, 19',
          'Jul 4, 19',
          'Jul 5, 19',
          'Jul 6, 19',
          'Jul 7, 19',
          'Jul 8, 19',
          'Jul 9, 19',
          'Jul 10, 19',
          'Jul 11, 19',
          'Jul 12, 19',
          'Jul 13, 19',
          'Jul 14, 19',
          'Jul 15, 19',
        ],
        datasets: [
          {
            label: 'Wallets added',
            backgroundColor: 'rgba(179,181,198,0.2)',
            borderColor: 'rgba(179,181,198,1)',
            pointBackgroundColor: 'rgba(179,181,198,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(179,181,198,1)',
            data: [4, 19, 6, 8, 10, 16, 12, 4, 15, 7, 10, 8, 24, 12, 3]
          }
        ]
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: false,
          custom: CustomTooltips,
          intersect: true,
          mode: 'index',
          position: 'nearest',
          callbacks: {
            labelColor: function (tooltipItem, chart) {
              return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor }
            }
          }
        }
      }
    )
  }
}
</script>
